<template lang="html">
	<div class="row">
		<div class="content content-components ml-5 pd-t-1-f pb-0">
			<div class="pd-x-0 pd-lg-x-10 pd-xl-x-0">
				<div class="row row-xs mt-3">
					<div class="col-sm-6 col-lg-4 p-0 pr-1">
						<div class="card card-body p-2 pd-y-0-f border-0">
							<div class="col-sm-6 col-lg-12 p-0 menu-label">
								<span class="fs-rem75 mr-5">접수 (등록) 현황 (건)</span>
								<span class="fs-rem75 float-right">
									<a class="mr-1 image-sample-font" @click="classifyReception('D')">일간</a>
									<a class="mr-1 image-sample-font" @click="classifyReception('W')">주간</a>
									<a class="image-sample-font" @click="classifyReception('M')">월간</a>
								</span>
							</div>
							<div class="col-sm-6 col-lg-12 p-0">
								<div class="card card-body">
									<apexchart type="bar" :options="receOption" :series="receSeries"></apexchart>
								</div>
							</div><!-- col -->
						</div>
					</div>
					<div class="col-sm-6 col-lg-4 p-0 pr-1">
						<div class="card card-body p-2 pd-y-0-f border-0">
							<div class="col-sm-6 col-lg-12 p-0 menu-label"><span class="fs-rem75 mr-5">업체별 접수 현황 (건)</span>
								<span class="fs-rem75 float-right">
									<a class="mr-1 image-sample-font" @click="classifyReceptionClient('CD')">일간</a>
									<a class="mr-1 image-sample-font" @click="classifyReceptionClient('CW')">주간</a>
									<a class="image-sample-font" @click="classifyReceptionClient('CM')">월간</a>
								</span>
							</div>
							<div class="col-sm-6 col-lg-12 p-0">
								<div class="card card-body">
									<apexchart type="bar" :options="clientOption" :series="clientSeries"></apexchart>
								</div>
							</div><!-- col -->
						</div>
					</div>
					<div class="col-sm-6 col-lg-4 p-0">
						<div class="card card-body p-2 pd-y-0-f border-0">
							<div class="col-sm-6 col-lg-12 p-0 menu-label"><span class="fs-rem75 mr-5">접수 현황 (월간) (최근 3년) (건)</span></div>
							<div class="col-sm-6 col-lg-12 p-0">
								<div class="card card-body">
									<apexchart type="line" :options="receYearOption" :series="receYearSeries"></apexchart>
								</div>
							</div><!-- col -->
						</div>
					</div>
				</div><!-- row row-xs -->
				<div class="row row-xs mb-1 mt-3">
					<!-- div class="col-sm-6 col-lg-4 p-0 pr-1">
						<div class="card card-body p-2 pd-y-0-f border-0">
							<div class="col-sm-6 col-lg-12 p-0 menu-label"><span class="fs-rem75 mr-5">NGS 현황 (건)</span></div>
							<div class="col-sm-6 col-lg-12 p-0">
								<div class="card card-body">
									<apexchart type="bar" :options="options3" :series="series4"></apexchart>
								</div>
							</div><!-- col -->
						<!-- /div>
					</div>
					<div class="col-sm-6 col-lg-4 p-0 pr-1">
						<div class="card card-body p-2 pd-y-0-f border-0">
							<div class="col-sm-6 col-lg-12 p-0 menu-label"><span class="fs-rem75 mr-5">분석 현황 (일간, 주간, 월간) (건)</span></div>
							<div class="col-sm-6 col-lg-12 p-0">
								<div class="card card-body">
									<apexchart type="bar" :options="options4" :series="series5"></apexchart>
								</div>
							</div><!-- col -->
						<!-- /div>
					</div>
					<div class="col-sm-6 col-lg-4 p-0">
						<div class="card card-body p-2 pd-y-0-f border-0">
							<div class="col-sm-6 col-lg-12 p-0 menu-label"><span class="fs-rem75 mr-5">결과 현황 (일간, 주간, 월간) (건)</span></div>
							<div class="col-sm-6 col-lg-12 p-0">
								<div class="card card-body">
									<apexchart type="bar" :options="options" :series="series"></apexchart>
								</div>
								
							</div><!-- col -->
						<!-- /div>
					</div-->
				</div><!-- row row-xs -->
			</div>
		</div>
	</div>
</template>
<script>
	// 공통 스크립트
	import common from "@/views/Common/common.js";
	import moment from "moment";
	//mport ngswork from '@/assets/svg/ngs-work.svg';
	// import ngsloading from '@/assets/svg/ngs-loadingbar.svg';
	// VueApexCharts


	export default {
		name: "Dashboard",
		props: ['properties'],
		data() {
			return {
				menuData: [],
				receOrderOption: {},
				receOption: {}, // width
				clientOption:{}, // client width
				receYearOption: {},
				expeDNAOption: {},
				expeOption: {},
				expeYearOption: {},
				plateOption: {},
				NGSOption: {},
				fileOption: {},
				analysisOption: {},
				resultOption: {},
				receOrderSeries: [],
				receSeries: [], // heigth
				clientSeries: [], // client heigth
				receYearSeries: [],
				expeDNASeries: [],
				expeSeries: [],
				expeYearSeries: [],
				plateSeries: [],
				NGSSeries: [],
				fileSeries: [],
				analysisSeries: [],
				resultSeries: [],
				defaultData: [],
				options: {
					chart: {
					id: 'vuechart-example'
					},
					xaxis: {
					categories: ['2020-01-07', '2020-01-08', '2020-01-09', '2020-01-10', '2020-01-11', '2020-01-12', '2020-01-13']
					}
				},
				series: [{
					name: 'Accugene',
					data: [2, 6, 1, 1, 2, 0, 2]
					},{
					name: 'Connectagen',
					data: [0, 5, 1, 1, 2, 0, 3]
					},
				],
				series2: [{
					name: 'plant',
					data: [2, 5, 2, 2, 2, 0, 2]
					},{
					name: 'blood',
					data: [0, 1, 0, 0, 0, 0, 1]
					},{
					name: 'urine',
					data: [0, 5, 0, 0, 2, 0, 2]
					},
				],
				options3: {
					chart: {
					id: 'vuechart-example'
					},
					xaxis: {
					categories: ['2020-01-07', '2020-01-09', '2020-01-11', '2020-01-13']
					}
				},
				series4: [{
					name: 'Miseq_Kor',
					data: [0, 0, 0, 0]
					},{
					name: 'Miseq_US',
					data: [60, 64, 60, 64]
					}
				],
				options4: {
					chart: {
					id: 'vuechart-example'
					},
					xaxis: {
					categories: ['2020-01-07', '2020-01-09', '2020-01-11', '2020-01-13']
					}
				},
				series5: [{
					name: 'Analyzing',
					data: [0, 0, 0, 10]
					},{
					name: 'Complete',
					data: [10, 10, 12, 0]
					}
				],
				series6: [{
					name: 'Result',
					data: [10, 0, 10, 0, 12, 0, 0]
					}
				],
			}
		},
		beforeDestroy(){
		},
		created(){
			this.classifyReception('D');
			this.classifyReceptionClient('CD');
			this.classifyReceptionYear();
		},
		mounted() {
		},
		components: {
			moment,
			//ngswork,
			// ngsloading,
		},
		methods: {
			/*
			* make default data
			*/
			async classifyDefaultData(gubun){
				this.defaultData = [];
				if(gubun === 'D' || gubun === 'CD' ){
					for(let i = 0;i < 7; i++){
						this.defaultData[i] = moment().add(-(6-i), 'days').format('YYYY-MM-DD')
					}
				}else if(gubun === 'W' || gubun === 'CW'){
					for(let i = 0;i < 7; i++){
						if(i === 5) this.defaultData[i] = 'a week ago'
						else if (i < 5) this.defaultData[i] = (6-i) + ' weeks ago'
						else this.defaultData[i] = 'this week'
					}
				}else if(gubun === 'M' || gubun === 'CM'){
					for(let i = 0;i < 7; i++){
						if(i === 5) this.defaultData[i] = 'a month ago'
						else if (i < 5) this.defaultData[i] = (6-i) + ' months ago'
						else this.defaultData[i] = 'this month'
					}
				}
			},
			/*
			* Load data
			*/
			async classifyReception(gubun) {
				this.classifyDefaultData(gubun);
				this.receSeries = []
				this.receSeries.push({name: 'Editing', data: []});
				this.receSeries.push({name: 'Confirm', data: []});
				let minVersion = [];
				let maxVersion = [];
				var params = [];
				params = {'gubun' : gubun};
				var request = {params : params}
				await this.$axios.get(this.$apiHost + "/dashboards/reception", request)
				.then(res => {
					if(gubun === 'D'){
						res.data.forEach(a=>{
							if(a.version < 1) minVersion.push(a);
							else maxVersion.push(a);
						});
						this.receOption = {
							chart: {stacked: true,},
							// plotOptions: {bar: {horizontal: true,},},
							stroke: {width: 1,colors: ['#fff']},
							xaxis: {categories: this.defaultData,labels: {formatter: function (val) {return val}}},
							yaxis: {title: {text: undefined},},
							tooltip: {y: {formatter: function (val) {return val}}},
							fill: {opacity: 1},
							legend: {show: true},
						}
						this.defaultData.forEach((a, b)=>{
							if(minVersion.length > 0){
								minVersion.forEach(c=>{
									if(a === c.createDate){
										this.receSeries[0].data[b] = c.cnt;
									}else{
										if(common.isNull(this.receSeries[0].data[b]))this.receSeries[0].data[b] = '0';
									}
								});
							}else{
								this.receSeries[0].data.push('0');
							}
							if(maxVersion.length > 0){
								maxVersion.forEach(c=>{
									if(a === c.createDate){
										this.receSeries[1].data[b] = c.cnt;
									}else{
										if(common.isNull(this.receSeries[1].data[b]))this.receSeries[1].data[b] = '0';
									}
								});
							}else{
								this.receSeries[1].data.push('0');
							}
						});
					}else if(gubun === 'W'){
						res.data.forEach((a, b)=>{
							if(a.version < 1) minVersion.push(a);
							else maxVersion.push(a);
						});

						this.receOption = {
							chart: {stacked: true,},
							// plotOptions: {bar: {horizontal: true,},},
							stroke: {width: 1,colors: ['#fff']},
							xaxis: {categories: this.defaultData,labels: {formatter: function (val) {return val}}},
							yaxis: {title: {text: undefined},},
							tooltip: {y: {formatter: function (val) {return val}}},
							fill: {opacity: 1},
							legend: {show: true},
						}
						if(minVersion.length > 0){
							this.receSeries[0].data[0] = maxVersion[0].w7;
							this.receSeries[0].data[1] = maxVersion[0].w6;
							this.receSeries[0].data[2] = maxVersion[0].w5;
							this.receSeries[0].data[3] = maxVersion[0].w4;
							this.receSeries[0].data[4] = maxVersion[0].w3;
							this.receSeries[0].data[5] = maxVersion[0].w2;
							this.receSeries[0].data[6] = maxVersion[0].w1;
						}
						if(maxVersion.length > 0){
							this.receSeries[1].data[0] = maxVersion[0].w7;
							this.receSeries[1].data[1] = maxVersion[0].w6;
							this.receSeries[1].data[2] = maxVersion[0].w5;
							this.receSeries[1].data[3] = maxVersion[0].w4;
							this.receSeries[1].data[4] = maxVersion[0].w3;
							this.receSeries[1].data[5] = maxVersion[0].w2;
							this.receSeries[1].data[6] = maxVersion[0].w1;
						}
					}else{
						res.data.forEach((a, b)=>{
							if(a.version < 1) minVersion.push(a);
							else maxVersion.push(a);
						});
						this.receOption = {
							chart: {stacked: true,},
							// plotOptions: {bar: {horizontal: true,},},
							stroke: {width: 1,colors: ['#fff']},
							xaxis: {categories: this.defaultData,labels: {formatter: function (val) {return val}}},
							yaxis: {title: {text: undefined},},
							tooltip: {y: {formatter: function (val) {return val}}},
							fill: {opacity: 1},
							legend: {show: true},
						}
						if(minVersion.length > 0){
							this.receSeries[0].data[0] = maxVersion[0].w7;
							this.receSeries[0].data[1] = maxVersion[0].w6;
							this.receSeries[0].data[2] = maxVersion[0].w5;
							this.receSeries[0].data[3] = maxVersion[0].w4;
							this.receSeries[0].data[4] = maxVersion[0].w3;
							this.receSeries[0].data[5] = maxVersion[0].w2;
							this.receSeries[0].data[6] = maxVersion[0].w1;
						}
						if(maxVersion.length > 0){
							this.receSeries[1].data[0] = maxVersion[0].w7;
							this.receSeries[1].data[1] = maxVersion[0].w6;
							this.receSeries[1].data[2] = maxVersion[0].w5;
							this.receSeries[1].data[3] = maxVersion[0].w4;
							this.receSeries[1].data[4] = maxVersion[0].w3;
							this.receSeries[1].data[5] = maxVersion[0].w2;
							this.receSeries[1].data[6] = maxVersion[0].w1;
						}
					}
				}).catch(err => {console.log(err);});
			},
			/*
			* Load data
			*/
			async classifyReceptionClient(gubun) {
				this.classifyDefaultData(gubun);
				this.clientSeries = []
				var params = [];
				params = {'gubun' : gubun};
				var request = {params : params}
				await this.$axios.get(this.$apiHost + "/dashboards/reception", request)
				.then(res => {
					if(gubun === 'CD'){
						this.clientOption = {
							chart: {stacked: true,},
							stroke: {width: 1,colors: ['#fff']},
							xaxis: {categories: this.defaultData,labels: {formatter: function (val) {return val}}},
							yaxis: {title: {text: undefined},},
							tooltip: {y: {formatter: function (val) {return val}}},
							fill: {opacity: 1},
							legend: {show: true},
						}
						let client = '';
						let idx = 0;
						res.data.forEach((a, b)=>{
							if(b === 0) {
								client = a.client
								this.clientSeries.push({name: a.client, data: [0,0,0,0,0,0,0]});
								idx++;
							}else if (client != a.client){
									this.clientSeries.push({name: a.client, data: [0,0,0,0,0,0,0]});
									idx++;
							}
							this.defaultData.forEach((c,d)=>{
								if(a.createDate === c) {
									this.clientSeries[idx-1].data[d] = a.cnt;
								}
							});
						});
					}else if(gubun === 'CW'){
						this.clientOption = {
							chart: {stacked: true,},
							stroke: {width: 1,colors: ['#fff']},
							xaxis: {categories: this.defaultData,labels: {formatter: function (val) {return val}}},
							yaxis: {title: {text: undefined},},
							tooltip: {y: {formatter: function (val) {return val}}},
							fill: {opacity: 1},
							legend: {show: true},
						}
						res.data.forEach((a, b)=>{
							this.clientSeries.push({name: a.client, data: [a.w7, a.w6, a.w5, a.w4, a.w3, a.w2, a.w1]})
						});
					}else if(gubun === 'CM'){
						this.clientOption = {
							chart: {stacked: true,},
							stroke: {width: 1,colors: ['#fff']},
							xaxis: {categories: this.defaultData,labels: {formatter: function (val) {return val}}},
							yaxis: {title: {text: undefined},},
							tooltip: {y: {formatter: function (val) {return val}}},
							fill: {opacity: 1},
							legend: {show: true},
						}
						res.data.forEach((a, b)=>{
							this.clientSeries.push({name: a.client, data: [a.w7, a.w6, a.w5, a.w4, a.w3, a.w2, a.w1]})
						});
					}
				}).catch(err => {console.log(err);});
			},
			/*
			* Load data
			*/
			async classifyReceptionYear() {
				this.receYearSeries.splice(0);
				let minVersion = [];
				let maxVersion = [];
				var params = [];
				//receYearOption
				params = {'gubun' : 'CY'};
				var request = {params : params}
				await this.$axios.get(this.$apiHost + "/dashboards/reception", request).then(res => {
					this.receYearOption = {
						chart: {
						id: 'year-chart'
						},
						xaxis: {
						categories: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']
						}
					}
					res.data.forEach(a => {
						this.receYearSeries.push({name: a.years, data: [a.w1, a.w2, a.w3, a.w4, a.w5, a.w6, a.w7, a.w8, a.w9, a.w10, a.w11, a.w12]});
					});
				}).catch(err => {console.log(err);});
			},
		},
		computed: {
		},
		watch: {
		},
	}
</script>


// WEBPACK FOOTER //
// src/views/Dashboard/Dashboard.vue